/**
 * Идентификатор для замера hero элемента
 */
export const ElementTimingHero = 'hero';
